/*
 * Export statements for Closure's use.
 */
jscc['enums'] = jscc.enums;
//noinspection ThisExpressionReferencesGlobalObjectJS
/** @suppress {globalThis} */
(this['jscc'] = jscc);
//>>includeStart("amdclean", pragmas.amdclean);
//noinspection ThisExpressionReferencesGlobalObjectJS
/** @suppress {globalThis|checkVars} */
(function(root) {
    if (typeof main !== "undefined") {
        (root['main'] = main);
    }
})(this);
//>>includeEnd("amdclean");
